import React, { ReactNode } from 'react'
import { ApolloClient, ApolloProvider } from '@apollo/client'

import styles from './graphql.module.scss'

export interface GraphqlProps {
  children: ReactNode
  client: ApolloClient<object>
}

export function Graphql({ children, client }: GraphqlProps) {
  return (
    <ApolloProvider client={client}>
      <div className={styles.container}>{children}</div>
    </ApolloProvider>
  )
}

export default Graphql

export * from './client'
export * from './generated/generated'
